let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ahXVU")).then(() => parcelRequire('9H2hz'));